// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2cfch","empty":"ModalGraph_empty__2jNnh"};